import { campaignStatus } from "../consts";
import dateUtil from "./dateUtil";

const getIsScheduled = (fwuCampaign) => {
  const { status, startDate } = fwuCampaign ?? {};

  const campaignStartDate = dateUtil.getUTCDate(new Date(startDate));
  const today = dateUtil.getUTCDate(new Date());

  const isDeactivated = status === campaignStatus.inactive;

  return campaignStartDate.getTime() > today.getTime() && !isDeactivated;
};

const fwuCampaignUtils = { getIsScheduled };

export default fwuCampaignUtils;
